import { ToastContentProps } from 'react-toastify/dist/types'

export type TToastifyCashoutNotificationProps<T = unknown> =
  ToastContentProps<T>

export const TOASTIFY_CASHOUT_ID = 'TOASTIFY_CASHOUT_ID'
